import {
  resourceNotificationsClient,
  type PaginatedResourceNotificationList,
  type ResourceNotification,
  type ResourceNotificationRequest,
  type ErrorEnvelopeError,
  isErrorEnvelopeError,
} from '@dynatrace-sdk/client-notification-v2';

import {
  useNotificationClient,
  type UseNotificationClientReturn,
} from './useNotificationClient.js';

/**
 * @internal
 */
export function useResourceNotificationClient(
  config: ResourceNotificationRequest,
): UseNotificationClientReturn {
  const notifications = useNotificationClient<
    ResourceNotificationRequest,
    ResourceNotification,
    PaginatedResourceNotificationList,
    ErrorEnvelopeError
  >('resource', config, {
    list: (config, abortSignal) =>
      resourceNotificationsClient.getResourceNotifications({
        notificationType: config.notificationType,
        resourceId: config.resourceId,
        abortSignal,
      }),
    create: (config) =>
      resourceNotificationsClient.createResourceNotification({
        body: config,
      }),
    destroy: (id) =>
      resourceNotificationsClient.deleteResourceNotification({
        id,
      }),
    isErrorEnvelopeError,
  });

  return notifications;
}
